<span class="crm-industrial-font" [ngClass]="'icon-' + icon">
  @for (i of numOfShapes; track i) {
    <span [ngClass]="'path' + i"></span>
  }
</span>